<template>
  <div class="app-wrapper">
    <sidebar class="sidebar-container" />
    <div class="main-container">
      <navbar />
      <app-main />
    </div>
  </div>
</template>

<script>
import Sidebar from './components/Sidebar'
import Navbar from './components/Navbar'
import AppMain from './components/AppMain'

export default {
  name: 'Layout',
  components: {
    Sidebar,
    Navbar,
    AppMain
  }
}
</script>

<style lang="scss" scoped>
.app-wrapper {
  display: flex;
  width: 100%;
  height: 100%;

  .sidebar-container {
    width: $sidebar-width;
    height: 100%;
    background-color: #304156;
    box-shadow: 2px 0 6px rgba(0, 0, 0, 0.1);
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    z-index: 1001;
    overflow: hidden;
  }

  .main-container {
    flex: 1;
    margin-left: $sidebar-width;
    min-height: 100%;
    transition: margin-left 0.28s;
    background-color: #f0f2f5;
  }
}
</style>